import React from 'react'

export default function LandingMainTwo() {
  return (
    <div className="container mx-auto">
      <div className="flex justify-center items-start">
        <div className="flex flex-col ">
          <div className="lg:self-center self-start font-semibold text-[40px] text-gray-33 ">Proje Yönetim Sistemi</div>
          <div className="lg:self-center self-start lg:text-center lg:text-[19px] leading-7 text-sm font-normal text-gray-44 lg:max-w-3xl max-w-md">
            Hey Pena, projelerini geliştirirken süreç takibinde sorun yaşayan ekipler ve güncellemeleri takip etmek isteyen herkes için geliştirildi.
          </div>
          <div>
            <img src="../../assets/landing/penakomp.png" alt="LandingMainTwo" className="lg:max-w-[746px] max-w-md mt-5" />
          </div>
        </div>
      </div>
    </div>
  )
}
